<script>
import resources from './resources'
import { TheMask } from 'vue-the-mask'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'patient-register-form',
  mixins: [resources],
  components: {
    TheMask
  }
}
</script>

<template lang="pug">
.authentication
  page
  .container
    .col-md-12.content-center
      .modal-backdrop(v-if="isShowing")
      .modal(
        style='z-index: 1040; padding-right: 15px; display: block;',
        aria-modal='true',
        v-show="isShowing"
        :class="{'modal-mobile': isMobiled}"
      )

        .modal-dialog(role='document')
          .modal-content
            .modal-header
              h4#defaultModalLabel.title Regimento Interno
              button.close(type='button', data-dismiss='modal', aria-label='Close', @click.prevent="doHide()")
                span(aria-hidden='true') ×

            .modal-body
              div#scroll-content
                #content-notice.modal-body
                    p
                      strong O CONDOMINIO RESIDENCIAL OHIO, LOCALIZADO
                      |  na Rua Marechal Octávio Saldanha Mazza, nº 6700, inscrito no CNPJ sob o nº
                      strong 26.114.799/0001-30
                      | , reger- se-á, para todos os efeitos de direito, pelo presente REGIMENTO INTERNO, Convenção Condominial e pela legislação vigente, especialmente as disposições do Código Civil, obrigando a todos os seus condôminos, moradores, visitantes, hóspedes, prestadores de serviços e empregados.
                    p
                      | Este regimento, aprovado pelos condôminos presentes na Assembleia Geral Extraordinária do Condomínio, realizada em
                      strong 17/11/2016
                      | , tem como finalidade estabelecer critérios de convivência entre todos os condôminos que residem neste condomínio, complementando e em conformidade com o que determina a legislação aplicada em vigor, como também as determinações da Convenção Condominial.
                    p
                      strong É PROIBIDO:
                    p
                      | 01 - Pisar ou brincar nas partes que compõem o jardim, bem como nele intervir, adicionando ou removendo plantas ou mudando-lhe o arranjo, sem autorização da assembleia.
                    p
                      | 02 - Depositar objetos ou outros materiais em qualquer das áreas de uso comum destinada a outros fins, isto é, entradas, passagens, corredores, escadas, vestíbulos, garagens e demais dependências de uso comum do condomínio.
                    p
                      | 03 - O uso de bola, skate, patins e bicicletas nas vias de passeio e estacionamentos do condominio, ou em quaisquer áreas que não sejam destinadas especificamente à prática de tais atividades. O uso de pipas é proibido em qualquer local do condomínio.
                    p
                      | 04 - Sujar, danificar, afixar cartazes ou avisos nas áreas comuns e fachada do prédio. As informações administrativas serão colocados no quadro de avisos destinado para tanto.
                    p
                      | 05 - Estender, bater ou secar tapetes, lençóis e/ou quaisquer roupas, bem como colocar vasos de plantas e objetos de peso nas janelas ou outros locais fronteiriços, nos quais também não é permitido instalar varais de qualquer tipo.
                    p
                      | 06 - Modificar as disposições das paredes internas de divisões de seu apartamento, bem como modificar a forma ou aspecto externo do edifício, sem a prévia autorização da Assembleia Geral dos Condôminos e dos demais órgãos competentes.
                    p
                      | 07 - Ter ou usar instalações ou materiais que por qualquer forma venham afetar a saúde, a segurança e a tranquilidade dos demais condôminos ou inquilinos que possam onerar as despesas do seguro comum obrigatório do condomínio.
                    p
                      | 08 - Manter ou guardar substâncias odoríferas ou que causem perigo à segurança do edifício ou dos seus moradores, tais como produtos químicos, inflamáveis, explosivos, botijões de gás, dentre outros que embora não elencados exponham o condomínio e os condôminos a risco desnecessário.
                    p
                      | 09 - Fazer uso de fogão, que não a gás (gás fornecido pelo condomínio) ou elétrico, sendo vedado terminantemente o emprego de outros tipos de combustível que não sejam considerados como de uso doméstico. Por exemplo: gasolina, querosene, diesel, carvão, dentre outros.
                    p
                      | 11 - Atirar pelas janelas para a rua ou área comum, no piso dos corredores, escadas, garagens e demais dependências do condomínio, fragmentos de lixo, papéis, pontas de cigarro e/ou quaisquer outros objetos ou resíduos.
                    p
                      | 12 - Fazer reparos no seu apartamento, sem o devido cumprimento do Art. 7 do Capítulo
                      strong "É DEVER"
                      |  e Art. 4 das
                      strong “DAS MUDANÇAS”
                      | , assim como promover festividades ou reuniões suscetíveis de prejudicar os pertences comuns ou de perturbar o sossego e a tranquilidade dos demais condôminos.
                    p
                      | 13 - Utilizar-se dos serviços dos empregados e/ou dos prestadores de serviço contratados pelo condominio para a realização de serviços particulares durante o expediente ou após o término do mesmo.
                    p
                      | 14 - Utilizar, alugar, ceder ou explorar no todo ou em parte os apartamentos para fins que não sejam estritamente residenciais, notadamente escolas de música ou de dança, cursos em geral, pensões, escritórios profissionais, rádio emissora (amador ou não), ensaio de banda, consultórios, laboratório, instituto de beleza, enfermarias, butiques, dependências consulares ou diplomáticas, e qualquer ramo de atividade de comércio, indústria e de prestação de serviços.
                    p 15 - Realizar lavagem ou conserto de veículos em qualquer área do condominio.
                    p
                      | 16 - Alugar ou ceder sua vaga na garagem, sob qualquer hipótese, para pessoas não residentes no condomínio. A cessão, por qualquer forma, a condômino, por sua vez, deverá ser realizada por escrito, devendo-se ainda comunicar ao Síndico e/ou os subsíndicos.
                    p
                      | 16.1 - O estacionamento de motocicletas em qualquer área comum, que não a respectiva garagem do apartamento.
                    p
                      | 17 - O proprietário do imóvel, ou quem detenha legalmente a sua posse, é responsável por danos e atos praticados por terceiros que sob sua autorização adentrem ao condominio.
                    p
                      | 18 - A utilização de cortinas ou forro a não ser nas cores brancas, bege claro ou cinza claro; grades e telas de proteção fora dos padrões permitidos.
                    p
                      strong É DEVER:
                    p
                      | 01 - Guardar silêncio a qualquer hora e especialmente no período das 22h00min às 08h00min horas, evitando a produção de ruídos e/ou sons que possam perturbar o sossego e o bem-estar dos demais moradores.
                    p
                      | 02 - Não perturbar os vizinhos em qualquer horário com o uso de aparelhos sonoros ou musicais.
                    p
                      | 03 - Tratar com respeito os empregados e/ou prestadores de serviços contratados pelo condomínio.
                    p
                      | 04. Toda reclamação e/ou sugestão deve ser dirigida ao representante de bloco ou ao síndico, após devidamente registrada no livro de ocorrências.
                    p
                      | 05 - Acondicionar o lixo em sacos apropriados, colocando-os nos coletores e cuidando para que não haja vazamento, separando o lixo orgânico do reciclável.
                    p
                      | 06 - Estacionar o veículo de acordo com as demarcações das vagas de seus respectivos apartamentos.
                    p
                      | 07 - Comunicar as mudanças totais ou parciais ao (a) Síndico (a), por escrito, com a assinatura do proprietário ou administradora do apartamento, com antecedência mínima de 2 (dois) dias do evento.
                    p
                      | 08 - Atualizar após a mudança, os dados cadastrais junto ao Síndico, que deverá repassá-los à administradora do condomínio.
                    p
                      | 9 - Apresentar ao Síndico documentação que comprove a transmissão da propriedade, posse ou a utilização do apartamento pelos novos moradores (inquilino ou proprietário)
                    p
                      | 10 - Comunicar ao Síndico os contatos dos proprietários não residentes para a facilitar o recebimento de correspondências e informativos internos. Dessa forma não poderão alegar em juízo ou fora dela a não recepção das mesmas e nem tampouco o desconhecimento do seu conteúdo.
                    p
                      | 11 - Prestigiar e fazer cumprir as decisões das Assembleias Gerais e a esta comparecer, a fim de que as decisões tomadas expressem, realmente, a vontade condominial.
                    p
                      | 12 - Observar dentro do condominio a mais rigorosa moralidade, decência e respeito.
                    p
                      | 13 - Notificar imediatamente o síndico, e/ou subsíndico, a incidência de moléstia infectocontagiosa grave que acometa algum dos residentes no seu apartamento.
                    p
                      | 14 - Permitir a entrada em sua unidade, do Síndico, Subsíndico e/ou Zelador e das pessoas que os acompanharem, sempre que solicitado, desde que se torne necessária e indispensável a inspeção e a execução de medidas que se relacionem ao interesse coletivo e exponham o condomínio a risco desnecessário.
                    p
                      | 15 - Contribuir, pontualmente, com toda e qualquer despesa aprovada nas Assembleias Gerais Ordinárias e Extraordinárias.
                    p
                      | 16 - Providenciar o conserto ou substituição de qualquer peça ou aparelho pertencente ao condomínio que tenha sido danificado por animais ou pessoas de sua relação, seja morador ou visitante. Em casos urgentes, o reparo será realizado pelo próprio condomínio e o reembolso das despesas deverá ser feito pelo condômino responsável, após o recebimento da notificação e o valor será inserido no boleto da taxa condominial subsequente.
                    p
                      | 17 - Fazer constar como parte integrante dos contratos de locação ou venda, exemplar deste regulamento.
                    p
                      | 18 - Manter fechadas as portas externas da sua unidade, assim como dos blocos. Em nenhuma hipótese o Condomínio poderá ser responsabilizado por furtos ou roubos ocorridos no seu interior.
                    p
                      | 19 - Avisar o síndico acerca de toda e qualquer irregularidade observada no interior do condomínio.
                    p
                      | 20 - Os condôminos que instalarem grades no interior das janelas das suas unidades deverão utilizar o modelo fixo tijolinho e/ou pantográfico, na cor branca.
                    p
                      strong DAS ÁREAS DE LAZER:
                    p
                      | 01 - O playground é limitado ao uso de crianças com até 6 (seis) anos de idade, acompanhadas pelos responsáveis.
                    p
                      | 02 - As crianças e os adultos poderão brincar nas áreas de lazer, sendo, todavia, vedados os jogos que possam colocar em risco a segurança dos moradores e do condomínio.
                    p
                      | 03 - As áreas de lazer ficarão disponíveis todos os dias das 08:00 às 22:00 horas, desde que as atividades não gerem transtornos aos demais condôminos.
                    p
                      strong DA SEGURANÇA:
                    p
                      | 01 - O portão da entrada social deverá ser fechado pelo morador após sua passagem.
                    p
                      | 02 - O portão da garagem deverá ser fechado pelo morador logo após a saída ou entrada do veiculo.
                    p
                      | 2.1 - O trânsito de veiculos dentro dos limites do condomínio é de no máximo 10 (dez) Km/h.
                    p
                      | 03 - Não será permitida a entrada de pessoas estranhas ao condomínio, sem prévia autorização do condômino solicitante. Os visitantes deverão aguardar na portaria até que o porteiro tenha obtido a necessária autorização. O condômino morador ficará responsável por toda atitude ou danos que forem causados pelo não visitante.
                    p
                      | 04 - Os prestadores de serviços contratados pelo condomínio ou pelos condôminos deverão apresentar documento de identificação na portaria e serem acompanhados pelo condômino durante toda a sua permanência no interior do Condomínio.
                    p
                      | 05 - Deve ser observado o teor dos artigos 14, 17 e 18, do capítulo
                      strong "É PROIBIDO"
                      |  e dos artigos 2.1 e 2.1.3, do capítulo
                      strong "DAS ÁREAS DE LAZER"
                      | , para entrada inadvertida de estranhos.
                    p
                      | 06 - O Condomínio não se responsabiliza por roubos, furtos, colisões, ou por quaisquer danos causados aos veículos em suas dependências.
                    p
                      strong DAS GARAGENS:
                    p
                      | 01 - Será permitido estacionar carros e motos na mesma vaga, ao mesmo tempo, desde que não ultrapassem os limites da vaga do condômino.
                    p
                      | 02 - Os veículos de terceiros que adentrarem clandestinamente ou por cessão temporária ou permanente ao estacionamento não estarão sob responsabilidade do condomínio em caso de sinistro de qualquer natureza.
                    p
                      | 2.1 - No caso de sinistro de qualquer natureza, inclusive os sucedidos envolvendo a segurança em geral do condominio, causados pelo veículo infrat (Art. 17, capítulo
                      strong "É PROIBIDO"
                      | ), o condômino “infrator" será responsabilizado.
                    p
                      strong DAS MUDANÇAS:
                    p
                      | 01 - Só serão permitidas mudanças totais (retirada total dos objetos do interior do apartamento) ou parciais (retirada parcial dos objetos do interior do apartamento) nos seguintes dias e horários:
                    p
                      strong De segunda à sexta das 09h00 às 17h00 horas e aos
                      br
                      strong Sábados das 09h00 às 14h00 horas.
                    p 02 - Não são permitidas mudanças aos domingos e aos feriados.
                    p
                      | 03 - É proibida a entrada de caminhões com peso superior a 3.000kg ao interior do condomínio.
                    p 04 - São permitidas obras e/ou pequenas reformas nos seguintes dias e horários:
                    p
                      strong
                        | De segunda à sexta-feira das 9:00 às 17:00 horas.
                        br
                        |       Sábados das 09ho0 às 14h00 horas.
                    p
                      | 05 - Não são permitidas as realizações de obras e/ou reparos aos domingos e aos feriados.
                    p
                      | 06 - Os animais de estimação serão tolerados, desde que não perturbem os demais moradores, não exalem odor excessivo, sejam vacinados, de pequeno porte, não sujem áreas comuns e permaneçam sob constante vigilância, com o uso da guia, do condômino responsável
                    p
                      | 07 - O condômino fica obrigado a retirar o entulho proveniente de sobras de reformas (madeira, concreto, tijolos, carpetes e demais objetos utilizados) de sua unidade para fora das dependências do condomínio, sendo proibida a utilização das lixeiras do condomínio para o acondicionamento dos entulhos.
                    p
                      | 08 - Os entulhos deverão ser acondicionados fora do condominio, respeitando as leis municipais, estaduais e/ou federais vigentes à época.
                    p
                      | 8.1 - o Condômino ficará responsável pelo não cumprimento do item 7, com as devidas sanções.
                    p
                      | 09 - O controle de abertura e fechamento do portão de veiculos será responsabilidade da Portaria e dos condôminos que possuírem os controles individuais.
                    p
                      strong DAS PENALIDADES:
                    p
                      | 01 - O condômino que violar as disposições legais, bem como as contidas neste Regimento, ficará sujeito à multa de 1 (uma) - taxa condominial vigente a época da infração. A multa será aplicada a todo condômino notificado pela segunda vez, independentemente de as notificações referirem-se a mesma infração. Em caso de reincidência (a partir da segunda notificação) o valor da multa será no valor de 2 taxas condominiais vigente à época da infração. Os casos de reincidência incorrerão na aplicação de multa equivalente ao dobro do valor da taxa (infringência às normas por três vezes), ao triplo do valor da taxa (infringência às normas por quatro vezes), ao quádruplo do valor da taxa (infringência às normas por cinco vezes) e ao quintuplo do valor da taxa (infringência às normas por seis vezes), até o limite de dez vezes a taxa condominial.
                    p
                      | 1.1 - Excetuando nesse caso as multas referentes ao item 2 do tópico "Área de Lazer" que deverão seguir o previsto nos artigos 2.8 e 2.12 do tópico “Area de Lazer”.
                    p
                      | 1.2 - A multa será imposta pelo Condomínio juntamente a taxa condominial, no vencimento imediatamente posterior ao da data da infração.
                    p
                      | 1.3 - O pagamento da multa não exime o infrator de sua responsabilidade pelos danos causados.
                    p
                      | 1.4 - Os casos omissos neste Regimento, na Convenção do Condomínio ou na legislação pertinente serão dirimidos em Assembleia específica para tal fim.
                    p
                      br
                      strong
                        | NÃO SERÁ ACEITA, EM QUALQUER HIPÓTESE, POR QUEM QUER QUE SEJA, ALEGAÇÃO DE DESCONHECIMENTO DAS NORMAS ESTABELECIDAS NESTE REGULAMENTO.

            .modal-footer
      .row
        .col-lg-6.col-md-12
            .company_detail
                h4.logo
                  router-link(:to="{name: 'auth.login'}")
                    img(src='/static/images/logo.svg', alt='')
                  br
                  span(style="font-size: 18px;") Condomum

                  //-ul.social_link.list-unstyled
                    li
                      a(href='https://thememakker.com', title='ThemeMakker')
                        i.zmdi.zmdi-globe
                    li
                      a(href='https://themeforest.net/user/thememakker', title='Themeforest')
                        i.zmdi.zmdi-shield-check
                    li
                      a(href='https://www.linkedin.com/company/thememakker/', title='LinkedIn')
                        i.zmdi.zmdi-linkedin
                    li
                      a(href='https://www.facebook.com/thememakkerteam', title='Facebook')
                        i.zmdi.zmdi-facebook
                    li
                      a(href='http://twitter.com/thememakker', title='Twitter')
                        i.zmdi.zmdi-twitter
                    li
                      a(href='http://plus.google.com/+thememakker', title='Google plus')
                        i.zmdi.zmdi-google-plus
                    li
                      a(href='https://www.behance.net/thememakker', title='Behance')
                        i.zmdi.zmdi-behance
                  hr
                  //-ul
                    li
                      a(href='http://thememakker.com/contact/', target='_blank') Contato
                    li
                      a(href='http://thememakker.com/about/', target='_blank') Sobre
                    li
                      a(href='http://thememakker.com/services/', target='_blank') Serviços
                    li
                      a(href='javascript:void(0);') FAQ
        .col-lg-5.col-md-12.offset-lg-1
          .card-plain

            .header
              h4 Ativação de Conta
            .form
              v-input(:status="$v.tenant.name.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='text',
                    v-model="tenant.name"
                    placeholder='Nome completo',
                    disabled
                  )
                  span.input-group-addon(style="background-color: #E3E3E3;")
                    i.zmdi.zmdi-account-circle
              v-input(:status="$v.tenant.email.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='text',
                    v-model="tenant.email"
                    placeholder='Informe seu email'
                    disabled
                  )
                  span.input-group-addon(style="background-color: #E3E3E3;")
                    i.zmdi.zmdi-email
              v-input(:status="$v.tenant.genre.$error ? 'error' : null")
                .input-group
                  f-select(
                    id="unit_id",
                    name="tower",
                    track-by="id",
                    label-by="name",
                    v-model="tenant.genre",
                    :options="optionsGenre",
                    :searchable="true",
                    :multiple="false",
                    placeholder='Sexo',
                    openDirection="bottom",
                    style="width: 100%;"
                  )

              v-input(:status="$v.tenant.phone.$error ? 'error' : null")
                .input-group
                  the-mask.form-control(
                    :mask="['(##) ####-####','(##) #####-####']",
                    name='text',
                    type='text',
                    placeholder='(00) 9 0000-0000'
                    v-model="tenant.phone"
                    autocomplete="off",
                    disabled
                  )
                  span.input-group-addon(style="background-color: #E3E3E3;")
                    i.zmdi.zmdi-phone

              v-input(:status="$v.tenant.country_register.$error ? 'error' : null")
                .input-group
                  the-mask.form-control(
                    :mask="['###.###.###.##']",
                    name='text',
                    type='text',
                    placeholder='CPF'
                    v-model="tenant.country_register"
                    autocomplete="off"
                  )
                  span.input-group-addon
                    i.zmdi.zmdi-card
              v-input(:status="$v.tenant.password.$error ? 'error' : null")
                .input-group
                  input.form-control(
                    type='password',
                    placeholder='Senha'
                    v-model="tenant.password"
                    )
                  span.input-group-addon
                    i.zmdi.zmdi-lock
              .checkbox
                input(
                  type='checkbox'
                  v-model="tenant.internal_regulation"
                )
                label(for='terms', @click.prevent="internalRegulation(tenant.internal_regulation)")
                  | Eu li e aceito os termos do &nbsp;
                  a(href='javascript:void(0);', @click.prevent="doShow()") Regimento Interno
            .footer

              a.btn.btn-primary.btn-round.btn-block(
                v-if="!tenant.internal_regulation"
                style="color: #fff;"
                disabled
              ) ATIVAR

              a.btn.btn-primary.btn-round.btn-block(
                v-if="tenant.internal_regulation"
                @click.prevent="doActive()"
                style="color: #fff;"
              ) ATIVAR
            router-link.link(:to="{ name: 'auth.login'}") Você já tem cadastro?
</template>
<style scoped>
#scroll-content > div {
    background: #fff;
    height: 40px;
    margin-bottom: 5px;
    text-align: justify;
    font-size: 11px;
}
  #scroll-content > div {
      background: #c0c0c0;
      height: 40px;
      margin-bottom: 5px;
      text-align: justify;
      font-size: 11px;
  }
  #scroll-content
  {
    min-height: 400px;
    overflow: auto;
  }
.checkbox-checked input[type="checkbox"]:checked+label::after {
    border-color: #7159c1;
    background: #7159c1;
    color: white;
}
.checkbox-checked label::after {
    font-family: 'Material-Design-Iconic-Font';
    content: "\f26b";
    top: 0px;
    text-align: center;
    font-size: 14px;
    opacity: 0;
    color: #555;
    border: 0;
    background-color: inherit;
        border-color: #7159c1;
    background: #7159c1;
    color: white;
}
.color-red {
  color: #f96332;
}
.v-select .v-select-bar {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    white-space: nowrap;
    margin-bottom: calc(0px - var(--padd));
    padding-left: 7px;
    width: 100%;
}
.v-select {
    position: relative;
    outline: none;
    border: 1px solid #E3E3E3;
    border-radius: 30px;
    width: 100%;
    margin-top: 4px;
    margin-bottom: 4px;
}
.v-select {
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  font: 400 12px system-ui;
}
.v-select .v-select-bar {
    margin-top: 4px;
    margin-bottom: 4px;
}
.v-select .v-select-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: .3em .5em;
  cursor: pointer;
  margin-right: 34px;
  border-radius: 30px;
}
.v-select .v-select-selected:first-of-type {
    padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/app/auth/active/tenant/form.vue